import HealthAndSafetyRoundedIcon from "@mui/icons-material/HealthAndSafetyRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import SportsHandballRoundedIcon from "@mui/icons-material/SportsHandballRounded";
import BiotechRoundedIcon from "@mui/icons-material/BiotechRounded";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import SportsEsportsRoundedIcon from "@mui/icons-material/SportsEsportsRounded";
import PaidRoundedIcon from "@mui/icons-material/PaidRounded";
import NewspaperRoundedIcon from "@mui/icons-material/NewspaperRounded";
import ConnectWithoutContactRoundedIcon from "@mui/icons-material/ConnectWithoutContactRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import MiscellaneousServicesRoundedIcon from "@mui/icons-material/MiscellaneousServicesRounded";

type TopicIconProps = {
  name: string;
  color?:
    | "inherit"
    | "action"
    | "disabled"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
  width?: number;
};

let iconMap = new Map();

export function TopicIcon(props: TopicIconProps) {
  var color = props.color;
  var width = props.width;
  var style = {
    width: props.width ? props.width + "px" : "24px",
    height: props.width ? props.width + "px" : "24px",
  };

  iconMap.set(
    "THỂ THAO",
    <SportsHandballRoundedIcon
      color={props.color ? props.color : "info"}
      style={style}
    />
  );
  iconMap.set(
    "GIÁO DỤC",
    <SchoolRoundedIcon
      color={props.color ? props.color : "disabled"}
      style={style}
    />
  );
  iconMap.set(
    "KHOA HỌC - CÔNG NGHỆ",
    <BiotechRoundedIcon
      color={props.color ? props.color : "info"}
      style={style}
    />
  );
  iconMap.set(
    "PHÁP LUẬT",
    <GavelRoundedIcon
      color={props.color ? props.color : "warning"}
      style={style}
    />
  );
  iconMap.set(
    "KINH TẾ",
    <PaidRoundedIcon color={props.color ? props.color : "success"} style={style} />
  );
  iconMap.set(
    "SỨC KHỎE - ĐỜI SỐNG",
    <HealthAndSafetyRoundedIcon
      color={props.color ? props.color : "error"}
      style={style}
    />
  );
  iconMap.set(
    "GIẢI TRÍ",
    <SportsEsportsRoundedIcon
      color={props.color ? props.color : "secondary"}
      style={style}
    />
  );
  iconMap.set(
    "TIN TỨC",
    <NewspaperRoundedIcon
      color={props.color ? props.color : "disabled"}
      style={style}
    />
  );
  iconMap.set(
    "CHÍNH TRỊ - XÃ HỘI",
    <ConnectWithoutContactRoundedIcon
      color={props.color ? props.color : "success"}
      style={style}
    />
  );
  iconMap.set(
    "THẾ GIỚI",
    <PublicRoundedIcon
      color={props.color ? props.color : "info"}
      style={style}
    />
  );
  if (iconMap.get(props.name.toUpperCase()) != null) {
    return iconMap.get(props.name.toUpperCase());
  }
  return (
    <MiscellaneousServicesRoundedIcon
      color={props.color ? props.color : "info"}
      style={style}
    />
  );
}
